import { render, staticRenderFns } from "./DownloadZip.vue?vue&type=template&id=47e472f4&scoped=true"
import script from "./DownloadZip.vue?vue&type=script&lang=js"
export * from "./DownloadZip.vue?vue&type=script&lang=js"
import style0 from "./DownloadZip.vue?vue&type=style&index=0&id=47e472f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e472f4",
  null
  
)

export default component.exports